const UsefullLinks = () => {
	return (
		<>
			<section className="contact py-80">
				<div className="container container-lg">
					<div className="row gy-5">
						<div className="col-lg-6">
							<div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
								<h4 className=" text-bold headingsize ">
									Usefull Links{" "}
									<span className="primecolor">Formulae & Table</span>
								</h4>

								<ul className="mt-32">
									<li className="text-gray-400 mb-14 flex-align gap-14 px-20">
										<span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
											<i className="ph ph-check"></i>
										</span>
										<a
											href="https://www.calculator.net/financial-calculator.html"
											target="_blank"
											rel="noopener noreferrer"
											className="text-heading fw-medium text-decoration-none"
										>
											FINANCIAL CALCULATOR
										</a>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14 px-20">
										<span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
											<i className="ph ph-check"></i>
										</span>
										<a
											href="https://www.xe.com/currencyconverter/convert/?Amount=1&From=AED&To=INR"
											target="_blank"
											rel="noopener noreferrer"
											className="text-heading fw-medium text-decoration-none"
										>
											CURRENCY CONVERTER
										</a>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14 px-20">
										<span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
											<i className="ph ph-check"></i>
										</span>
										<a
											href="https://www.calculator.net/fitness-and-health-calculator.html"
											target="_blank"
											rel="noopener noreferrer"
											className="text-heading fw-medium text-decoration-none"
										>
											FITNESS & HEALTH CALCULATOR
										</a>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14 px-20">
										<span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
											<i className="ph ph-check"></i>
										</span>
										<a
											href="https://www.bmi-calculator.net/weight-loss-calculator/"
											target="_blank"
											rel="noopener noreferrer"
											className="text-heading fw-medium text-decoration-none"
										>
											BMI (BODY MASS INDEX) CALCULATOR
										</a>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14 px-20">
										<span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
											<i className="ph ph-check"></i>
										</span>
										<a
											href="https://www.calculator.net/math-calculator.html"
											target="_blank"
											rel="noopener noreferrer"
											className="text-heading fw-medium text-decoration-none"
										>
											MATHS CALCULATOR
										</a>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14 px-20">
										<span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
											<i className="ph ph-check"></i>
										</span>
										<a
											href="https://www.steelexpress.co.uk/steel-weight-calculator.html"
											target="_blank"
											rel="noopener noreferrer"
											className="text-heading fw-medium text-decoration-none"
										>
											STEEL WEIGHT CALCULATOR
										</a>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14 px-20">
										<span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
											<i className="ph ph-check"></i>
										</span>
										<a
											href="https://www.calculatorsoup.com/calculators/construction/tank.php"
											target="_blank"
											rel="noopener noreferrer"
											className="text-heading fw-medium text-decoration-none"
										>
											TANK VOLUME CALCULATOR
										</a>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14 px-20">
										<span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
											<i className="ph ph-check"></i>
										</span>
										<a
											href="http://www.calcul.com/show/calculator/area-conversion"
											target="_blank"
											rel="noopener noreferrer"
											className="text-heading fw-medium text-decoration-none"
										>
											AREA CONVERSION TABLE
										</a>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14 px-20">
										<span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
											<i className="ph ph-check"></i>
										</span>
										<a
											href="https://www.distance.to/"
											target="_blank"
											rel="noopener noreferrer"
											className="text-heading fw-medium text-decoration-none"
										>
											DISTANCE BETWEEN CITIES
										</a>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14 px-20">
										<span className="w-20 h-20 bg-main-50 text-light text-xs flex-center rounded-circle">
											<i className="ph ph-check"></i>
										</span>
										<a
											href="https://calculator.com/"
											target="_blank"
											rel="noopener noreferrer"
											className="text-heading fw-medium text-decoration-none"
										>
											CALCULATOR
										</a>
									</li>
								</ul>
							</div>
						</div>
						<div className="col-lg-6">
							<h6 className="  text-center">
								<a
									href="https://www.calculatorsoup.com/calculators/construction/tank.php"
									target="_blank"
									rel="noopener noreferrer"
								>
									TANK VOLUME CALCULATOR{" "}
								</a>
							</h6>

							<div className="d-flex justify-content-center">
								<a
									href="https://www.calculatorsoup.com/calculators/construction/tank.php"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										src="assets/images/about/tank-cyl.jpg"
										alt=""
										className=" rounded-16 about"
									/>
								</a>
							</div>

							<h6 className=" text-center">
								<a
									href="https://www.steelexpress.co.uk/steel-weight-calculator.html"
									target="_blank"
									rel="noopener noreferrer"
									className="text-center"
								>
									STEEL WEIGHT CALCULATOR
								</a>
							</h6>

							<div className="d-flex justify-content-center">
								<a
									href="https://www.steelexpress.co.uk/steel-weight-calculator.html"
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										src="assets/images/about/steel-vl.png"
										alt=""
										className="  about"
									/>
								</a>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
export default UsefullLinks;
